<template>
  <div class="bg-white">
    <header>
      <Popover class="relative bg-white">
        <div class="flex justify-between items-center max-w-7xl mx-auto px-4 py-6 sm:px-6 md:justify-start md:space-x-10 lg:px-8">
          <div class="flex justify-start lg:w-0 lg:flex-1">
            <router-link to="/">
              <span class="sr-only">Barespend</span>
              <svg width="120" height="24.159995583000047" viewBox="0 0 120 24.159995583000047" class="css-1j8o68f"><defs id="SvgjsDefs2431"></defs><g id="SvgjsG2432" featurekey="UxBHKT-0" transform="matrix(1.3422218346063925,0,0,1.3422218346063925,-1.3422218346063925,-8.053328447553374)" fill="#4f46e5"><path d="M4 15 c0 1.48 0.74 2.32 2.24 2.32 c0.42 0 0.8 -0.06 1.1 -0.2 c0.56 -0.22 0.94 -0.64 1.14 -1.22 c0.08 -0.28 0.12 -0.58 0.12 -0.9 s-0.04 -0.62 -0.12 -0.9 c-0.22 -0.62 -0.56 -0.96 -1.14 -1.24 c-0.3 -0.12 -0.68 -0.18 -1.1 -0.18 c-1.5 0 -2.24 0.84 -2.24 2.32 z M1 6 l3 0 l0 5 c0.68 -0.78 1.6 -1.1 2.62 -1.1 c2.92 0 4.98 2.34 4.98 5.14 c0 3.16 -2.34 5.06 -5.32 5.06 c-3.1 0 -5.28 -2.04 -5.28 -5.1 l0 -9 z M19.128 15 c-0.08 -1.46 -0.74 -2.32 -2.26 -2.32 c-0.42 0 -0.78 0.06 -1.08 0.18 c-0.92 0.42 -1.26 1.2 -1.26 2.16 c0 0.32 0.04 0.62 0.14 0.88 c0.3 1.04 1.2 1.42 2.2 1.42 c1.52 0 2.26 -0.82 2.26 -2.32 z M22.928 20 l-3 0 c-0.2 -0.5 -0.38 -1 -0.5 -1.52 c-0.68 1.12 -1.72 1.62 -3 1.62 c-2.86 0 -4.9 -2.4 -4.9 -5.14 c0 -3.16 2.36 -5.06 5.34 -5.06 c3.18 0 5.18 2.04 5.26 5.1 c0.02 0.26 0.02 0.56 0.02 0.92 c0 1.4 0.22 2.8 0.78 4.08 z M26.236 15 l0 5 l-3 0 l0 -4.98 c0 -3.32 2.44 -5.12 5.52 -5.12 c0.1 0 0.24 0 0.38 0.02 s0.3 0.06 0.44 0.08 l0 2.9 c-0.1 -0.02 -0.22 -0.04 -0.36 -0.06 s-0.26 -0.04 -0.36 -0.04 c-0.5 0 -0.9 0.06 -1.24 0.16 c-0.56 0.2 -1.06 0.58 -1.24 1.18 c-0.1 0.26 -0.14 0.56 -0.14 0.86 z M32.384 13.8 c0.3 0.1 0.64 0.18 1 0.22 c0.36 0.06 0.7 0.08 1.02 0.08 c0.4 0 1.42 -0.08 1.42 -0.66 c0 -0.62 -0.88 -0.64 -1.32 -0.64 c-0.88 0 -1.64 0.2 -2.12 1 z M38.044 16.88 l0 2.8 c-1.12 0.26 -2.24 0.44 -3.4 0.44 c-3.18 0 -5.54 -1.86 -5.54 -5.08 c0 -3.18 2.28 -5.14 5.3 -5.14 c2.06 0 4.44 0.98 4.44 3.32 c0 2.32 -2.52 3.18 -4.46 3.18 c-0.74 0 -1.48 -0.2 -2.16 -0.48 c0.4 1.12 1.6 1.3 2.64 1.3 c0.54 0 1.08 -0.02 1.62 -0.1 c0.5 -0.04 1.08 -0.1 1.56 -0.24 z M38.972 19.68 l0 -2.8 c1.32 0.4 2.98 0.48 4.34 0.48 c0.54 0 0.96 -0.02 1.26 -0.08 c0.28 -0.04 0.42 -0.14 0.42 -0.28 c0 -0.06 -0.02 -0.1 -0.06 -0.16 c-0.2 -0.2 -0.64 -0.3 -0.9 -0.36 s-0.6 -0.14 -1.02 -0.22 c-0.34 -0.06 -0.74 -0.14 -1.2 -0.24 c-1.56 -0.34 -2.76 -1.22 -2.76 -2.9 c0 -2.48 2.42 -3.22 4.46 -3.22 c1.28 0 2.56 0.18 3.82 0.44 l0 2.82 c-1.26 -0.38 -2.68 -0.48 -4 -0.48 c-0.52 0 -0.88 0.02 -1.1 0.08 s-0.34 0.16 -0.34 0.28 c0 0.18 0.18 0.3 0.52 0.36 c0.34 0.08 0.82 0.18 1.4 0.28 c0.52 0.1 1.02 0.2 1.5 0.32 c1.48 0.38 2.54 1.18 2.54 2.78 c0 2.68 -2.7 3.34 -4.86 3.34 c-1.36 0 -2.7 -0.18 -4.02 -0.44 z M51.38 15 c0 1.48 0.74 2.32 2.24 2.32 c0.42 0 0.8 -0.06 1.1 -0.2 c0.56 -0.22 0.94 -0.64 1.14 -1.22 c0.08 -0.28 0.12 -0.58 0.12 -0.9 s-0.04 -0.62 -0.12 -0.9 c-0.22 -0.62 -0.56 -0.96 -1.14 -1.24 c-0.3 -0.12 -0.68 -0.18 -1.1 -0.18 c-1.5 0 -2.24 0.84 -2.24 2.32 z M51.38 19 l0 5 l-3 0 l0 -9 c0 -3.2 2.26 -5.1 5.28 -5.1 c3.08 0 5.32 2.02 5.32 5.08 c0 2.84 -2.14 5.12 -4.98 5.12 c-0.58 0 -1.08 -0.1 -1.5 -0.3 c-0.44 -0.18 -0.82 -0.46 -1.12 -0.8 z M62.188 13.8 c0.3 0.1 0.64 0.18 1 0.22 c0.36 0.06 0.7 0.08 1.02 0.08 c0.4 0 1.42 -0.08 1.42 -0.66 c0 -0.62 -0.88 -0.64 -1.32 -0.64 c-0.88 0 -1.64 0.2 -2.12 1 z M67.848 16.88 l0 2.8 c-1.12 0.26 -2.24 0.44 -3.4 0.44 c-3.18 0 -5.54 -1.86 -5.54 -5.08 c0 -3.18 2.28 -5.14 5.3 -5.14 c2.06 0 4.44 0.98 4.44 3.32 c0 2.32 -2.52 3.18 -4.46 3.18 c-0.74 0 -1.48 -0.2 -2.16 -0.48 c0.4 1.12 1.6 1.3 2.64 1.3 c0.54 0 1.08 -0.02 1.62 -0.1 c0.5 -0.04 1.08 -0.1 1.56 -0.24 z M79.436 15 l0 5 l-3 0 l0 -5 c0 -1.38 -0.64 -2.32 -2.1 -2.32 c-1.44 0 -2.1 0.96 -2.1 2.32 l0 5 l-3 0 l0 -5 c0 -3.08 2.12 -5.1 5.1 -5.1 c3.1 0 5.1 2.12 5.1 5.1 z M87.404 15 c0 -1.5 -0.74 -2.32 -2.26 -2.32 c-0.42 0 -0.78 0.06 -1.08 0.18 c-0.56 0.26 -0.94 0.64 -1.12 1.24 c-0.1 0.28 -0.14 0.58 -0.14 0.9 s0.04 0.62 0.14 0.9 c0.16 0.58 0.58 1 1.12 1.22 c0.3 0.14 0.66 0.2 1.08 0.2 c1.52 0 2.26 -0.82 2.26 -2.32 z M87.404 11 l0 -5 l3 0 l0 9 c0 3.18 -2.26 5.1 -5.28 5.1 c-3.08 0 -5.32 -2 -5.32 -5.06 c0 -2.82 2.08 -5.14 4.92 -5.14 c1.06 0 1.98 0.3 2.68 1.1 z"></path></g></svg>
            </router-link>
          </div>
          <div class="-mr-2 -my-2 md:hidden">
            <PopoverButton class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
              <span class="sr-only">Open menu</span>
              <MenuIcon class="h-6 w-6" aria-hidden="true" />
            </PopoverButton>
          </div>
          <PopoverGroup as="nav" class="hidden md:flex space-x-10">
            <!-- <Popover class="relative" v-slot="{ open }">
              <PopoverButton :class="[open ? 'text-gray-900' : 'text-gray-500', 'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500']">
                <span>Product</span>
                <ChevronDownIcon :class="[open ? 'text-gray-600' : 'text-gray-400', 'ml-2 h-5 w-5 group-hover:text-gray-500']" aria-hidden="true" />
              </PopoverButton>

              <transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
                <PopoverPanel class="absolute z-10 -ml-4 mt-3 transform w-screen max-w-md lg:max-w-2xl lg:ml-0 lg:left-1/2 lg:-translate-x-1/2">
                  <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
                    <div class="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8 lg:grid-cols-2">
                      <router-link v-for="item in solutions" :key="item.name" :to="item.href" class="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50">
                        <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white sm:h-12 sm:w-12">
                          <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
                        </div>
                        <div class="ml-4">
                          <p class="text-base font-medium text-gray-900">
                            {{ item.name }}
                          </p>
                          <p class="mt-1 text-sm text-gray-500">
                            {{ item.description }}
                          </p>
                        </div>
                      </router-link>
                    </div>
                  </div>
                </PopoverPanel>
              </transition>
            </Popover> -->

            <!-- <a href="#" class="text-base font-medium text-gray-500 hover:text-gray-900">
              Pricing
            </a>
            <a href="#" class="text-base font-medium text-gray-500 hover:text-gray-900">
              Partners
            </a> -->
          </PopoverGroup>
          <div class="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
            <router-link to="/about" class="text-base font-medium text-gray-500 hover:text-gray-900 px-8">
              About Us
            </router-link>
            <a href="https://app.barespend.com" class="whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900">
              Sign in
            </a>
            <a href="" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/joeldsouza/30min'});return false;" class="ml-8 whitespace-nowrap inline-flex items-center justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white hover:from-purple-700 hover:to-indigo-700">
              Get a demo
            </a>
          </div>
        </div>

        <transition enter-active-class="duration-200 ease-out" enter-from-class="opacity-0 scale-95" enter-to-class="opacity-100 scale-100" leave-active-class="duration-100 ease-in" leave-from-class="opacity-100 scale-100" leave-to-class="opacity-0 scale-95">
          <PopoverPanel focus class="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
            <div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
              <!-- <div class="pt-5 pb-6 px-5">
                <div class="flex items-center justify-between">
                  <div>
                    <svg width="120" height="24.159995583000047" viewBox="0 0 120 24.159995583000047" class="css-1j8o68f"><defs id="SvgjsDefs2431"></defs><g id="SvgjsG2432" featurekey="UxBHKT-0" transform="matrix(1.3422218346063925,0,0,1.3422218346063925,-1.3422218346063925,-8.053328447553374)" fill="#4f46e5"><path d="M4 15 c0 1.48 0.74 2.32 2.24 2.32 c0.42 0 0.8 -0.06 1.1 -0.2 c0.56 -0.22 0.94 -0.64 1.14 -1.22 c0.08 -0.28 0.12 -0.58 0.12 -0.9 s-0.04 -0.62 -0.12 -0.9 c-0.22 -0.62 -0.56 -0.96 -1.14 -1.24 c-0.3 -0.12 -0.68 -0.18 -1.1 -0.18 c-1.5 0 -2.24 0.84 -2.24 2.32 z M1 6 l3 0 l0 5 c0.68 -0.78 1.6 -1.1 2.62 -1.1 c2.92 0 4.98 2.34 4.98 5.14 c0 3.16 -2.34 5.06 -5.32 5.06 c-3.1 0 -5.28 -2.04 -5.28 -5.1 l0 -9 z M19.128 15 c-0.08 -1.46 -0.74 -2.32 -2.26 -2.32 c-0.42 0 -0.78 0.06 -1.08 0.18 c-0.92 0.42 -1.26 1.2 -1.26 2.16 c0 0.32 0.04 0.62 0.14 0.88 c0.3 1.04 1.2 1.42 2.2 1.42 c1.52 0 2.26 -0.82 2.26 -2.32 z M22.928 20 l-3 0 c-0.2 -0.5 -0.38 -1 -0.5 -1.52 c-0.68 1.12 -1.72 1.62 -3 1.62 c-2.86 0 -4.9 -2.4 -4.9 -5.14 c0 -3.16 2.36 -5.06 5.34 -5.06 c3.18 0 5.18 2.04 5.26 5.1 c0.02 0.26 0.02 0.56 0.02 0.92 c0 1.4 0.22 2.8 0.78 4.08 z M26.236 15 l0 5 l-3 0 l0 -4.98 c0 -3.32 2.44 -5.12 5.52 -5.12 c0.1 0 0.24 0 0.38 0.02 s0.3 0.06 0.44 0.08 l0 2.9 c-0.1 -0.02 -0.22 -0.04 -0.36 -0.06 s-0.26 -0.04 -0.36 -0.04 c-0.5 0 -0.9 0.06 -1.24 0.16 c-0.56 0.2 -1.06 0.58 -1.24 1.18 c-0.1 0.26 -0.14 0.56 -0.14 0.86 z M32.384 13.8 c0.3 0.1 0.64 0.18 1 0.22 c0.36 0.06 0.7 0.08 1.02 0.08 c0.4 0 1.42 -0.08 1.42 -0.66 c0 -0.62 -0.88 -0.64 -1.32 -0.64 c-0.88 0 -1.64 0.2 -2.12 1 z M38.044 16.88 l0 2.8 c-1.12 0.26 -2.24 0.44 -3.4 0.44 c-3.18 0 -5.54 -1.86 -5.54 -5.08 c0 -3.18 2.28 -5.14 5.3 -5.14 c2.06 0 4.44 0.98 4.44 3.32 c0 2.32 -2.52 3.18 -4.46 3.18 c-0.74 0 -1.48 -0.2 -2.16 -0.48 c0.4 1.12 1.6 1.3 2.64 1.3 c0.54 0 1.08 -0.02 1.62 -0.1 c0.5 -0.04 1.08 -0.1 1.56 -0.24 z M38.972 19.68 l0 -2.8 c1.32 0.4 2.98 0.48 4.34 0.48 c0.54 0 0.96 -0.02 1.26 -0.08 c0.28 -0.04 0.42 -0.14 0.42 -0.28 c0 -0.06 -0.02 -0.1 -0.06 -0.16 c-0.2 -0.2 -0.64 -0.3 -0.9 -0.36 s-0.6 -0.14 -1.02 -0.22 c-0.34 -0.06 -0.74 -0.14 -1.2 -0.24 c-1.56 -0.34 -2.76 -1.22 -2.76 -2.9 c0 -2.48 2.42 -3.22 4.46 -3.22 c1.28 0 2.56 0.18 3.82 0.44 l0 2.82 c-1.26 -0.38 -2.68 -0.48 -4 -0.48 c-0.52 0 -0.88 0.02 -1.1 0.08 s-0.34 0.16 -0.34 0.28 c0 0.18 0.18 0.3 0.52 0.36 c0.34 0.08 0.82 0.18 1.4 0.28 c0.52 0.1 1.02 0.2 1.5 0.32 c1.48 0.38 2.54 1.18 2.54 2.78 c0 2.68 -2.7 3.34 -4.86 3.34 c-1.36 0 -2.7 -0.18 -4.02 -0.44 z M51.38 15 c0 1.48 0.74 2.32 2.24 2.32 c0.42 0 0.8 -0.06 1.1 -0.2 c0.56 -0.22 0.94 -0.64 1.14 -1.22 c0.08 -0.28 0.12 -0.58 0.12 -0.9 s-0.04 -0.62 -0.12 -0.9 c-0.22 -0.62 -0.56 -0.96 -1.14 -1.24 c-0.3 -0.12 -0.68 -0.18 -1.1 -0.18 c-1.5 0 -2.24 0.84 -2.24 2.32 z M51.38 19 l0 5 l-3 0 l0 -9 c0 -3.2 2.26 -5.1 5.28 -5.1 c3.08 0 5.32 2.02 5.32 5.08 c0 2.84 -2.14 5.12 -4.98 5.12 c-0.58 0 -1.08 -0.1 -1.5 -0.3 c-0.44 -0.18 -0.82 -0.46 -1.12 -0.8 z M62.188 13.8 c0.3 0.1 0.64 0.18 1 0.22 c0.36 0.06 0.7 0.08 1.02 0.08 c0.4 0 1.42 -0.08 1.42 -0.66 c0 -0.62 -0.88 -0.64 -1.32 -0.64 c-0.88 0 -1.64 0.2 -2.12 1 z M67.848 16.88 l0 2.8 c-1.12 0.26 -2.24 0.44 -3.4 0.44 c-3.18 0 -5.54 -1.86 -5.54 -5.08 c0 -3.18 2.28 -5.14 5.3 -5.14 c2.06 0 4.44 0.98 4.44 3.32 c0 2.32 -2.52 3.18 -4.46 3.18 c-0.74 0 -1.48 -0.2 -2.16 -0.48 c0.4 1.12 1.6 1.3 2.64 1.3 c0.54 0 1.08 -0.02 1.62 -0.1 c0.5 -0.04 1.08 -0.1 1.56 -0.24 z M79.436 15 l0 5 l-3 0 l0 -5 c0 -1.38 -0.64 -2.32 -2.1 -2.32 c-1.44 0 -2.1 0.96 -2.1 2.32 l0 5 l-3 0 l0 -5 c0 -3.08 2.12 -5.1 5.1 -5.1 c3.1 0 5.1 2.12 5.1 5.1 z M87.404 15 c0 -1.5 -0.74 -2.32 -2.26 -2.32 c-0.42 0 -0.78 0.06 -1.08 0.18 c-0.56 0.26 -0.94 0.64 -1.12 1.24 c-0.1 0.28 -0.14 0.58 -0.14 0.9 s0.04 0.62 0.14 0.9 c0.16 0.58 0.58 1 1.12 1.22 c0.3 0.14 0.66 0.2 1.08 0.2 c1.52 0 2.26 -0.82 2.26 -2.32 z M87.404 11 l0 -5 l3 0 l0 9 c0 3.18 -2.26 5.1 -5.28 5.1 c-3.08 0 -5.32 -2 -5.32 -5.06 c0 -2.82 2.08 -5.14 4.92 -5.14 c1.06 0 1.98 0.3 2.68 1.1 z"></path></g></svg>
                  </div>
                  <div class="-mr-2">
                    <PopoverButton class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                      <span class="sr-only">Close menu</span>
                      <XIcon class="h-6 w-6" aria-hidden="true" />
                    </PopoverButton>
                  </div>
                </div>
                <div class="mt-6">
                  <nav class="grid grid-cols-1 gap-7">
                    <router-link v-for="item in solutions" :key="item.name" :to="item.href" class="-m-3 p-3 flex items-center rounded-lg hover:bg-gray-50">
                      <div class="flex-shrink-0 flex items-center justify-center h-10 w-10 rounded-md bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
                        <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
                      </div>
                      <div class="ml-4 text-base font-medium text-gray-900">
                        {{ item.name }}
                      </div>
                    </router-link>
                  </nav>
                </div>
              </div> -->
              <div class="py-6 px-5">
                <div class="grid grid-cols-2 gap-4">
                  <!-- <a href="#" class="text-base font-medium text-gray-900 hover:text-gray-700">
                    Pricing
                  </a>
                  <a href="#" class="text-base font-medium text-gray-900 hover:text-gray-700">
                    Partners
                  </a> -->
                  <router-link to="/about" class="text-base font-medium text-gray-900 hover:text-gray-700">
                    About Us
                  </router-link>
                </div>
                <div class="mt-6">
                  <a href="" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/joeldsouza/30min'});return false;" class="w-full flex items-center justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white hover:from-purple-700 hover:to-indigo-700">
                    Get a demo
                  </a>
                  <p class="mt-6 text-center text-base font-medium text-gray-500">
                    Existing customer?
                    <a href="https://app.barespend.com" class="text-gray-900">
                      Sign in
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </PopoverPanel>
        </transition>
      </Popover>
    </header>

    <main>
      <router-view></router-view>
    </main>

    <footer class="bg-gray-50" aria-labelledby="footer-heading">
      <h2 id="footer-heading" class="sr-only">Footer</h2>
      <div class="max-w-7xl mx-auto pt-16 pb-8 px-4 sm:px-6 lg:pt-24 lg:px-8">
        <div class="xl:grid xl:grid-cols-3 xl:gap-8">
          <div class="grid grid-cols-2 gap-8 xl:col-span-2">
            <!-- <div class="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                  Product
                </h3>
                <ul class="mt-4 space-y-4">
                  <li v-for="item in footerNavigation.solutions" :key="item.name">
                    <router-link :to="item.href" class="text-base text-gray-500 hover:text-gray-900">
                      {{ item.name }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="mt-12 md:mt-0">
                <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                  Integrations
                </h3>
                <ul class="mt-4 space-y-4">
                  <li v-for="item in footerNavigation.integrations" :key="item.name">
                    <router-link :to="item.href" class="text-base text-gray-500 hover:text-gray-900">
                      {{ item.name }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div> -->
            <div class="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                  Company
                </h3>
                <ul class="mt-4 space-y-4">
                  <li v-for="item in footerNavigation.company" :key="item.name">
                    <router-link :to="item.href" class="text-base text-gray-500 hover:text-gray-900">
                      {{ item.name }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="mt-12 md:mt-0">
                <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">
                  Legal
                </h3>
                <ul class="mt-4 space-y-4">
                  <li v-for="item in footerNavigation.legal" :key="item.name">
                    <router-link :to="item.href" class="text-base text-gray-500 hover:text-gray-900">
                      {{ item.name }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- <div class="mt-12 xl:mt-0">
            <h3 class="text-sm font-semibold text-gray-400 tracking-wider uppercase">
              Subscribe to our newsletter
            </h3>
            <p class="mt-4 text-base text-gray-500">
              The latest news, articles, and resources, sent to your inbox weekly.
            </p>
            <form class="mt-4 sm:flex sm:max-w-md">
              <label for="email-address" class="sr-only">Email address</label>
              <input type="email" name="email-address" id="email-address" autocomplete="email" required="" class="appearance-none min-w-0 w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-4 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:placeholder-gray-400" placeholder="Enter your email" />
              <div class="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:flex-shrink-0">
                <button type="submit" class="w-full flex items-center justify-center bg-gradient-to-r from-purple-600 to-indigo-600 bg-origin-border px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white hover:from-purple-700 hover:to-indigo-700">
                  Subscribe
                </button>
              </div>
            </form>
          </div> -->
        </div>
        <div class="mt-12 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between lg:mt-16">
          <div class="flex space-x-6 md:order-2">
            <a v-for="item in footerNavigation.social" :key="item.name" :href="item.href" class="text-gray-400 hover:text-gray-500">
              <span class="sr-only">{{ item.name }}</span>
              <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
            </a>
          </div>
          <p class="mt-8 text-base text-gray-400 md:mt-0 md:order-1">
            &copy; {{ new Date().getFullYear() }} Barespend, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<style>
  @import "https://rsms.me/inter/inter.css";
</style>

<script>
import { defineComponent, h } from 'vue'
import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from '@headlessui/vue'
import {
  BriefcaseIcon,
  InboxIcon,
  MenuIcon,
  RefreshIcon,
  SparklesIcon,
  XIcon,
} from '@heroicons/vue/outline'
import { ChevronDownIcon } from '@heroicons/vue/solid'

const solutions = [
  {
    name: 'Reimbursements',
    description: 'Eliminate expense reports, reimburse quickly and easily.',
    href: '#',
    icon: InboxIcon,
  },
  { name: 'Insights', description: "Real-time insights for all non-payroll spend.", href: '#', icon: SparklesIcon },
  {
    name: 'Approval Workflows',
    description: 'Request and approval workflows. Easy, fast, upfront compliance.',
    href: '#',
    icon: RefreshIcon,
  },
  {
    name: 'Accounting Automation',
    description: "Save time and improve accuracy.",
    href: '#',
    icon: BriefcaseIcon,
  },
]
const footerNavigation = {
  solutions: [
    { name: 'Reimbursements', href: '#' },
    { name: 'Insights', href: '#' },
    { name: 'Approval Workflows', href: '#' },
    { name: 'Accounting Automation', href: '#' },
  ],
  integrations: [
    { name: 'QuickBooks', href: '/#integrations' },
    { name: 'Sage Intacct', href: '/#integrations' },
    { name: 'Xero', href: '/#integrations' }
    // { name: 'FreshBooks', href: '/#integrations' },
    // { name: 'NetSuite', href: '/#integrations' },    
  ],
  support: [
    { name: 'Documentation', href: '#' },
    // { name: 'Pricing', href: '#' },    
    // { name: 'Guides', href: '#' },
    // { name: 'API Status', href: '#' },
  ],
  company: [
    { name: 'About', href: '/about' },
    { name: 'Security', href: '/security' },
    // { name: 'Blog', href: '#' },
    // { name: 'Jobs', href: '#' },
    // { name: 'Press', href: '#' },
    // { name: 'Partners', href: '#' },
  ],
  legal: [
    // { name: 'Claim', href: '#' },
    { name: 'Privacy', href: '/privacy-policy' },
    { name: 'Terms', href: '/terms-and-conditions' },
  ],
  social: [
    // {
    //   name: 'Facebook',
    //   href: '#',
    //   icon: defineComponent({
    //     render: () =>
    //       h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
    //         h('path', {
    //           'fill-rule': 'evenodd',
    //           d:
    //             'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z',
    //           'clip-rule': 'evenodd',
    //         }),
    //       ]),
    //   }),
    // },
    // {
    //   name: 'Instagram',
    //   href: '#',
    //   icon: defineComponent({
    //     render: () =>
    //       h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
    //         h('path', {
    //           'fill-rule': 'evenodd',
    //           d:
    //             'M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z',
    //           'clip-rule': 'evenodd',
    //         }),
    //       ]),
    //   }),
    // },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/barespend',
      icon: defineComponent({
        render: () =>
          h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
            h('path', {
              'fill-rule': 'evenodd',
              d:
                'M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 8c0 .557-.447 1.008-1 1.008s-1-.45-1-1.008c0-.557.447-1.008 1-1.008s1 .452 1 1.008zm0 2h-2v6h2v-6zm3 0h-2v6h2v-2.861c0-1.722 2.002-1.881 2.002 0v2.861h1.998v-3.359c0-3.284-3.128-3.164-4-1.548v-1.093z',
              'clip-rule': 'evenodd',
            }),
          ]),
      }),
    },
    {
      name: 'Twitter',
      href: 'https://twitter.com/barespend',
      icon: defineComponent({
        render: () =>
          h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
            h('path', {
              d:
                'M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84',
            }),
          ]),
      }),
    },
    // {
    //   name: 'GitHub',
    //   href: 'https://github.com/barespend',
    //   icon: defineComponent({
    //     render: () =>
    //       h('svg', { fill: 'currentColor', viewBox: '0 0 24 24' }, [
    //         h('path', {
    //           'fill-rule': 'evenodd',
    //           d:
    //             'M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z',
    //           'clip-rule': 'evenodd',
    //         }),
    //       ]),
    //   }),
    // },
  ],
}

window.$crisp=[];
window.CRISP_WEBSITE_ID="12c93f42-0464-412d-9164-18c572195d74";

(function (c, l, a, r, i, t, y) {
  c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
  t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
  y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
})(window, document, "clarity", "script", "ecof3n661y");

export default {
  name: 'App',
  components: {
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    ChevronDownIcon,
    InboxIcon,
    MenuIcon,
    SparklesIcon,
    XIcon,
  },
  setup() {
    return {
      solutions,
      footerNavigation,
    }
  },
  mounted() {
    let crispExternalScript = document.createElement('script')
    crispExternalScript.setAttribute('src', 'https://client.crisp.chat/l.js')
    document.head.appendChild(crispExternalScript)

    let calendlyExternalStyle = document.createElement('link')
    calendlyExternalStyle.setAttribute('href', 'https://assets.calendly.com/assets/external/widget.css')
    calendlyExternalStyle.setAttribute('rel', 'stylesheet')
    document.head.appendChild(calendlyExternalStyle)

    let calendlyExternalScript = document.createElement('script')
    calendlyExternalScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
    document.head.appendChild(calendlyExternalScript)
  },
}
</script> 
